<template>
  <div>
    <div v-if="item && !loadingItems">
      <h1 class="title has-text-centered">{{ item.name }}</h1>
      <div class="columns">
        <div class="column is-3">
          <ItemImage
            class="itemImageBig"
            type="items"
            :id="item.id"
          />
        </div>
        <div class="column">
          {{ item.description }}
          <div v-if="item.base_cost" class="mt-5">
            Costs about <strong>{{ item.base_cost }} currants</strong>.
          </div>
          <div v-if="item.stackmax" class="mt-5">
            Fits <strong>{{ item.stackmax }}</strong> in a slot.
          </div>
          <div v-if="item.capacity" class="mt-5">
            Has <strong>{{ item.capacity }}</strong> slots.
          </div>
          <div v-if="item.npcs.length > 0" class="mt-6">
            <h5 class="title is-6">You can buy <strong>{{ item.name }}</strong> from:</h5>
            <items-list type="inhabitants" :items="item.npcs" />
          </div>

          <div v-if="item.achievements.length > 0" class="mt-5">
            <h5 class="title is-6">{{ item.name }} will let you achieve:</h5>
            <items-list
              :items="item.achievements"
              type="achievements"
            />
          </div>
        </div>
      </div>

      <div v-if="item.recipes_output.length > 0" class="mt-6">
        <h5 class="title is-6">You can create <strong>{{ item.name }}</strong> by:</h5>
        <recipe-list type="output" :recipes="item.recipes_output" />
      </div>

      <div v-if="item.recipes_input.length > 0" class="mt-6">
        <h5 class="title is-6">You can use <strong>{{ item.name }}</strong> to make:</h5>
        <recipe-list type="input" :recipes="item.recipes_input" />
      </div>

      <div v-if="item.recipes_tool.length > 0" class="mt-6">
        <h5 class="title is-6">You can use <strong>{{ item.name }}</strong> to make:</h5>
        <recipe-list type="tool" :recipes="item.recipes_tool" />
      </div>
    </div>

    <b-loading :is-full-page="false" v-model="loadingItems"></b-loading>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ItemImage from '@/components/Encyclopedia/ItemImage.vue';
import RecipeList from '@/components/Encyclopedia/RecipeList.vue';
import ItemsList from '@/components/Encyclopedia/ItemsList.vue';

export default {
  name: 'ItemDetails',
  metaInfo() {
    return {
      title: `${this.item?.name || 'Item'}`,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: `${this.item?.description || 'Item'} - Odd Giants Game items encyclopedia`,
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'encyclopedia, items, tools, food, drink, storage, basic resources, potions, machines, collectibles, quest, odd, giants, glitch, game, remake, multiplayer, online, mmorpg',
        },
      ],
    };
  },
  components: { ItemsList, RecipeList, ItemImage },
  props: {
    category: String,
    itemId: String,
  },
  computed: {
    ...mapState('encyclopedia', ['loadingItems', 'item']),
  },
  mounted() {
    this.loadItem(this.itemId);
  },
  beforeRouteUpdate(to, from, next) {
    this.loadItem(to.params.itemId);
    next();
  },
  methods: {
    async loadItem(itemId) {
      await this.$store.dispatch('encyclopedia/loadItemDetails', itemId);
    },
  },
};
</script>
